import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 18px;
  padding: 16px 0;
`;

export const ReviewButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
  padding: 8px 12px;
  background: #22c55e;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ExamCard = styled.div`
  width: 260px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;

  margin: 0 !important;

  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    background: #f0f0f0;
    transform: scale(1.02);

    ${ReviewButton} {
      background: #16a34a;
    }
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 16px;
  color: #333;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Label = styled.span`
  color: #666;
  margin-right: 4px;
`;

export const Value = styled.span`
  font-weight: 700;
  color: #1a1a1a;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 14px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top-color: #5768FF;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
